<div class="reporting-stations-dashboard">
  <sc-flex [vertical]="true" [stretchContent]="true" [fitHeight]="true">
    
    <div class="menu widget-menu-layer-1">
      <span class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></span>
      <span class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</span>
      <span class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></span>
    </div>

    <sc-content-spacer [vertical]="true"></sc-content-spacer>

    <sc-flex-fitting-content [vertical]="true">
      <app-stacked-bar-chart [data]="data.chart" *ngIf=" data != null"></app-stacked-bar-chart>
    </sc-flex-fitting-content>

  </sc-flex>

</div>